import { ReferenceList } from "../../../../components/referenceList";
import { toogleDiscounts } from "../../../../api/discounts";
import { setDiscountSearch } from "../../../../reducers/userConfigSlice";
import {
  discountPeriod,
  discountPeriodDetail,
  discountState,
  discountType,
  discountUses,
  discountValue,
} from "./discountListModel";
const states = [
  ["active", "Activo", "Activos"],
  ["scheduled", "Programado", "Programados"],
  ["expired", "Caducado", "Caducados"],
  ["inactive", "Inactivo", "Inactivos"],
];
export const DiscountList = ({ rows, onEdit, now = Date.now() }) => {
  const definition = {
    key: "discount",
    idKey: "discountId",
    singular: "descuento",
    plural: "descuentos",
    nameLabel: "Código",
    searchKey: "discountSearch",
    setSearch: setDiscountSearch,
    nameTitle: (row) =>
      `${row.discountCode || "Sin código"} · ${row.originalName || ""}`,
    tabs: () => [
      { id: "all", label: "Todos" },
      ...states
        .filter(
          ([id]) =>
            id !== "inactive" ||
            rows.some((row) => discountState(row, now) === "inactive"),
        )
        .map(([id, , label]) => ({
          id,
          label,
          matches: (row) => discountState(row, now) === id,
        })),
    ],
    filterId: "discount-type",
    filterLabel: "Tipo",
    filterOptions: () => [
      { value: "percentage", label: "Porcentaje" },
      { value: "value", label: "Importe fijo" },
    ],
    matchesFilter: (row, type) => row.type === type,
    searchText: (row) => `${row.name} ${row.originalName || ""}`,
    selectAllLabel: "Seleccionar todos los descuentos de esta página",
    bulkRemove: false,
    canRemove: () => false,
    exportEnabled: false,
    toggle: toogleDiscounts,
    columns: [
      { key: "type", label: "TIPO", render: discountType },
      {
        key: "value",
        label: "VALOR",
        className: "discountNumeric",
        render: discountValue,
      },
      {
        key: "uses",
        label: "USOS",
        className: "discountNumeric",
        render: discountUses,
      },
      {
        key: "period",
        label: "VIGENCIA",
        render: (row) => (
          <span className="discountPeriod" title={discountPeriodDetail(row)}>
            {discountPeriod(row, now)}
          </span>
        ),
      },
      {
        key: "state",
        label: "ESTADO",
        render: (row) => (
          <span
            className={`discountState ${discountState(row, now)}`}
            title="Estado según activación y vigencia; las condiciones se comprueban al aplicar el descuento"
          >
            {states.find(([id]) => id === discountState(row, now))[1]}
          </span>
        ),
      },
    ],
  };
  return (
    <ReferenceList
      rows={rows}
      definition={definition}
      onEdit={(row) => onEdit({ ...row, name: row.originalName })}
    />
  );
};
